import React from 'react';
import Hero from '../components/Hero/Hero';

const LandingPage = () => {
  return <Hero/>;
};

export default LandingPage;
